
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image/[[...slug]]",
      function () {
        return require("private-next-pages/image/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image/[[...slug]]"])
      });
    }
  